import { useLocation } from 'react-router-dom';
import Header from 'app/components/Header';
import OstroDynamicContent from 'app/components/OstroDynamicContent';

import TailorFaqButton from '../components/TailorFaqButton';
import useLinks from '../hooks/useLinks';
import useTailorTracking from '../hooks/useTailorTracking';
import useInterstitialPage from '../hooks/useInterstitialPage';

export default function TailorInterstitial() {
  const { captureInterstitialClick } = useTailorTracking();
  const { getLinkTarget } = useLinks();
  const { getInterstitialPageForURL } = useInterstitialPage();
  const { state } = useLocation();
  const destination = state?.destination;
  const page = getInterstitialPageForURL(destination);

  if (!destination) {
    return null;
  }

  const interstitialType = page.domains?.length ? 'specific' : 'general';

  return (
    <div
      id="ostro-tailor-interstitial-container"
      className="grow overflow-y-auto px-7 py-6"
    >
      <Header showIndicationSelector={false} />
      <OstroDynamicContent
        className="mt-4 mb-6"
        content={page.header_text}
      />
      <OstroDynamicContent
        className="mb-6"
        content={page.content_text}
      />
      <div>
        <TailorFaqButton
          href={destination}
          target={getLinkTarget(destination)}
          onClick={() => captureInterstitialClick(destination, interstitialType)}
          buttonText={page.button_text}
        />
      </div>
    </div>
  );
}
